namespace SorAraBul {
    export enum MaritalStatus {
        evli = 0,
        bekar = 1
    }
    Serenity.Decorators.registerEnumType(MaritalStatus, 'SorAraBul.MaritalStatus');
}
